import React from 'react';
import { CircularProgress } from '@mui/material';
import { useFetchStatistics, useAppSelector } from '../../hooks/redux';
import PaymentTab from './components/PaymentTab';
import { parseDate } from '../../utils/common';

import css from './DashboardPage.module.scss';
import { getMappedSumTabs } from './utils';
import { EDirection } from '../../store/reducers/enumTypes';

const DashboardPage = () => {
  useFetchStatistics();

  const { statistics, loading } = useAppSelector((state) => state.dashboardReducer);
  const todayDateTitle = parseDate(new Date(), 'MMMM dd, yyyy');

  if (loading) {
    return <CircularProgress />;
  }

  const tabsSums = getMappedSumTabs(statistics);

  return (
    <section className={css.root}>
      <div className={css.header}>Dashboard</div>
      <div className={css.date}>{`Date: ${todayDateTitle}`}</div>
      <div className={css.panels}>
        <PaymentTab title="#  of outgoing payments" count={tabsSums.outward} direction={EDirection.OUTWARD} />
        <PaymentTab title="#  of incoming payments" count={tabsSums.inward} direction={EDirection.INWARD} />
        <PaymentTab title="#  of transfers" count={tabsSums.transfer} direction={EDirection.TRANSFER} />
        <PaymentTab title="#  of FX transactions" count={tabsSums.fx} direction={EDirection.FX} />
      </div>

      <div className={css.table}>
        <div className={css.head}>
          <div className={css.col1}>Channel</div>
          <div className={css.col2}>Outgoing</div>
          <div className={css.col3}>Incoming</div>
          <div className={css.col4}>Transfers</div>
          <div className={css.col5}>FX</div>
        </div>
        <ul className={css.body}>
          {statistics?.map((item, index) => (
            <li key={`statistic_${index}`} className={css.item}>
              <div className={css.col1}>{item.bankName}</div>
              <div className={css.col2}>{item.outward}</div>
              <div className={css.col3}>{item.inward}</div>
              <div className={css.col4}>{item.transfer}</div>
              <div className={css.col5}>{item.fx}</div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default DashboardPage;
